import { html } from 'lit';

import '../../library/elements/d-label.js';
import '../../library/elements/d-action.js';
import '../../library/elements/d-section.js';
import '../../library/fields/d-expansion.js';
import '../../library/editors/elements/d-select-dropdown.js';
import '../../library/components/d-popup.js';
import '../../library/fields/d-view-info';

import { customElement, property, query } from 'lit/decorators.js';
import type { DPopup } from 'src/library/components/d-popup.js';
import { BaseDialog } from 'src/library/components/BaseDialog.js';
import { t } from 'src/i18n';
import type { HideDoneOptions } from './hide-done-options';
import type { HideDoneOptionsResult } from './hide-done-options-result';
import type { HideDoneOptionsInput } from './hide-done-options-input';

/**
 *
 * USAGE:
 *    d-events-page-content
 *
 * STATUS OK
 */
@customElement('hide-done-options-dialog')
export class HideDoneOptionsDialog extends BaseDialog<HideDoneOptionsInput, HideDoneOptionsResult> {
  @property({ type: String })
  value: HideDoneOptions = '1';
  @query('d-popup')
  popup!: DPopup;
  footerActions = [
    { name: t('common:cancel'), action: 'cancel' },
    { name: t('events.hideDoneDone'), action: 'save', main: true },
  ];
  width = 400;
  title = t('events.hideDoneTitle');
  private options = [
    { value: '0', text: t('events.hideDoneOptionImmediately') },
    { value: '1', text: t('events.hideDoneOptionAfterOneDay') },
    { value: '7', text: t('events.hideDoneOptionAfterOneWeek') },
    { value: '28', text: t('events.hideDoneOptionAfterFourWeeks') },
    { value: '365', text: t('events.hideDoneOptionAfterOneYear') },
  ];

  onValueChanged(e: CustomEvent<{ value: '0' | '1' | '7' | '28' | '1000' }>) {
    this.value = e.detail.value;
  }

  renderBody() {
    return html`
      <d-section>
        <d-view-info .content=${t('events.hideDoneInfo')}></d-view-info>
      </d-section>
      <d-section>
        <d-select-dropdown
          label="${t('events.hideDoneMoveLabel')}"
          .options=${this.options}
          .value=${this.value}
          @value-changed=${this.onValueChanged}
        ></d-select-dropdown>
      </d-section>
    `;
  }

  protected fetchResult(detail: string | undefined): HideDoneOptionsResult {
    return {
      value: this.value,
      action: detail === 'save' ? 'done' : 'cancel',
    };
  }

  protected initializeDialog(input: HideDoneOptionsInput) {
    this.value = input.value === '1000' ? '365' : input.value;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hide-done-options-dialog': HideDoneOptionsDialog;
  }
}
